<template>
  <b-modal :id="modalId" size="md">
    <template #modal-header>
      Delete Confirmation
    </template>

    <template #default>
      Are you sure, you want to delete this feature enabled "{{featureToDelete.name}}"?
    </template>

    <template #modal-footer>
      <b-button variant="secondary" size="md" @click="closeModal">
        <i class="far fa-times-circle"></i> Cancel
      </b-button>
      <b-button variant="danger" size="md" @click="onSubmit" :disabled="deletingInProgress">
        <b-spinner small v-if="deletingInProgress"></b-spinner>
        <span class="ml-standard" v-if="deletingInProgress">Deleting...</span>
        <span v-if="!deletingInProgress"><i class="fas fa-trash"></i> Delete</span>
      </b-button>
    </template>
  </b-modal>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      modalId: {
        type: String,
        default: 'modal-enabled-delete-confirmation'
      },
      onSuccess: {
        required: true,
        type: Function
      }
    },
    data() {
      return {
        featureToDelete: {
          id: null,
          name: ''
        },
        deletingInProgress: false
      };
    },
    methods: {
      showModal(featureToDelete) {
        this.featureToDelete = featureToDelete;
        this.$bvModal.show(this.modalId)
      },
      closeModal() {
        this.$bvModal.hide(this.modalId)
      },
      onSubmit() {
        this.deletingInProgress = true;
        axios.delete(`/api/mockConfig/feature/${this.featureToDelete.id}`)
          .then(response => {
            this.onSuccess();
            this.closeModal();
          })
          .catch(e => {
            this.$onError(e);
          })
          .finally(() => {
            this.deletingInProgress = false;
          })
      }
    }
  };
</script>
